import React,{useState} from "react";
import Sidebar from "../components/Sidebar/Index";
import Header from "../components/Header/Index";
import Footer from "../components/Footer/Index";
import FullpageLoader from "../components/FullPageLoader/";
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';
import { useIdleTimer } from 'react-idle-timer' 
import CustomModal from "../components/Modal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logLastActivity } from "../http/auth.service";


function LayoutWrapper({ childComponent }) {
  const navigate = useNavigate();
  const fullPageLoader = useSelector((data) => data.loader.fullPageLoader);
  const SESSION_IDLE_MINUTES = 30;
  const LOGOUT_AFTER_MILLISEC = 1000 * 60;
  const [showModal,setShowModal] = useState(false);
  let myTimeout;
  const onPrompt = () => {
    setShowModal(true);
  }

  const onIdle =  () => {
    myTimeout = setTimeout(async () => {
      await logLastActivity(getLastActiveTime())
      navigate("/logout");
      toast.warn("Session Expired");
    }, LOGOUT_AFTER_MILLISEC);
  }

  const onActive = () => {
    setShowModal(false);
    clearTimeout(myTimeout);
  }

 
  const {
    getLastActiveTime,
  } = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    timeout: 1000 * 60 * SESSION_IDLE_MINUTES,
    promptTimeout: 3000,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'visibilitychange'
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    name: 'idle-timer',
    syncTimers: 0,
    leaderElection: false
  });


  return (
    <>
      <div className="main-wrapper">
        {fullPageLoader && <FullpageLoader />}
        {/* Modal Will Show Here */}
        <CustomModal
            show={showModal}
            onHide={() => setShowModal(false)}
          />
        {/* End Modal */}
        <div className="left-sidebar">
          <Sidebar />
        </div>
        <div className="main-content">
          <Header />
          {childComponent}
        </div>
      </div>
      <div className="site-footer">
        <Footer />
      </div>
    </>
  );
}

LayoutWrapper.propTypes = {
  childComponent: PropTypes.object.isRequired
}

export default LayoutWrapper;
